import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from "react-toastify";

import { getStudentListSvc } from '../slidesSvc';
import StudentTable from './studentsTable';
import TopperForm from './topperForm';

const TopperSliderForm = (props) => {
    const { closeSlider, classId, sectionId, ptmId, examId, exam, classSection, topperRank, topperObj, updateKey } = props;

    const [editLoader, setEditLoader] = useState("none");
    const [editOpacity, setEditOpacity] = useState(1);
    const [studentId, setStudentId] = useState(0);
    const [lstClassStudents, setLstClassStudents] = useState([]);
    const [student, setStudent] = useState("");
    const [imgPath, setImgPath] = useState(window.appURL + "/no-image.png");
    const [score, setScore] = useState(0);

    useEffect(() => {
        // console.log("ToppersliderForm called");
        getStudentList(classId, sectionId);
    }, [classId, sectionId]);

    useEffect(() => {
        // console.log("ToppersliderForm called, topperObj", topperObj);
        if (topperObj) {
            setStudent(topperObj.student);
            setStudentId(topperObj.studentId);
            setImgPath(topperObj.imgPath);
            setScore(topperObj.score);
        }
    }, [topperObj]);

    const getStudentList = (pClsId, pSectionId) => {
        // console.log("getStudentList called, pClsId", pClsId, ", pSectionId", pSectionId);
        setEditLoader("block");
        setEditOpacity(0.5);
        getStudentListSvc(pClsId, pSectionId, studentListRespone);
    }

    const studentListRespone = (data) => {
        // console.log("studentListRespone called, data", data);
        if (data.status === "Success") {
            setLstClassStudents(data.lstClassStudents);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setEditLoader("none");
        setEditOpacity(1);
    }


    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };


    return (
        <div>
            <button
                type="button"
                className="btn btn-info text-center btnCloseDiv"
                onClick={closeSlider}
                style={{ right: "80%" }}
            >
                <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
            </button>
            <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '58%', top: '45%', display: editLoader }}>
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div>
            <div className="col-md-12 col-xs-12 col-centered padding-remove "
                style={{
                    cursor: (editLoader === "none") ? 'pointer' : 'none',
                    pointerEvents: (editLoader === "none") ? 'auto' : 'none',
                    opacity: editOpacity
                }}>
                <div className="col-md-12 col-xs-12 col-centered" style={{ marginTop: "40px" }}>
                    <div className="col-md-5 col-xs-12 padding-remove">
                        <div className="col-md-12 col-xs-12 padding-remove" >
                            <div className="col-md-4 col-xs-4 padding-remove" >
                                {/* {exam} */}
                            </div>
                            <div className="col-md-4 col-xs-4 padding-remove pull-right text-right" >
                                {/* {classSection} */}
                            </div>
                        </div>
                        <div className="col-md-12 col-xs-12 padding-remove" >
                            <StudentTable
                                lstStudent={lstClassStudents}
                                studentId={studentId}
                                setStudentId={setStudentId}
                                setStudent={setStudent}
                            />
                        </div>
                    </div>
                    <div className="col-md-7 col-xs-12 padding-remove">
                        <TopperForm
                            setEditLoader={setEditLoader}
                            setEditOpacity={setEditOpacity}
                            ptmId={ptmId}
                            sectionId={sectionId}
                            examId={examId}
                            studentId={studentId}
                            student={student}
                            topperRank={topperRank}
                            score={score}
                            setScore={setScore}
                            imgPath={imgPath}
                            updateKey={updateKey}
                            closeSlider={closeSlider}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TopperSliderForm;